export default __webpack_public_path__ + "static/media/linkedinIcon.2796182f.svg";